// extracted by mini-css-extract-plugin
module.exports = {"page":"LoginPage_page__2921G page_page__31uF2"};